module.exports = __webpack_public_path__ + "static/media/robotics.ec8611eb.png";